import { configureStore } from "@reduxjs/toolkit";
import layoutReducer from "./features/layoutSlice";
import providerReducer from "./features/providerSlice";
import providerFiltersReducer from "./features/providerFiltersSlice";
import rfisColorReducer from "./features/rfisColors";
import loggedInUserReducer from "./features/loggedInUserSlice"; // Fixed file path
import clientSecretsReducer from "./features/clientSecretsSlice"; // Fixed file path
import userRightsReducer from "./features/userRightsSlice"; // Fixed file path
import VendorUserDetailsReducer from "./features/vendorUserDetailsSlice"; // Fixed file path
import chatDQPReducer from "./features/chatDQPSlice"; // Fixed file path
import indicationsDashboardFiltersReducer from "./features/indicationsDashboardFiltersSlice";
import uiReducer from "./features/uiSlice"; // UI freeze state for role switching

const store = configureStore({
  reducer: {
    layout: layoutReducer,
    providers: providerReducer,
    providersFilters: providerFiltersReducer,
    rfisColors: rfisColorReducer,
    loggedInUser: loggedInUserReducer,
    clientSecrets: clientSecretsReducer,
    userRights: userRightsReducer,
    vendorUserDetails: VendorUserDetailsReducer,
    chatDQP: chatDQPReducer,
    indicationsDashboardFilters: indicationsDashboardFiltersReducer,
    ui: uiReducer, // UI freeze state for role switching
  },
});

export default store;
